import { gql } from 'urql'

// === QUERIES ===

export const GET_USERS = gql`
  query GetUsers($filter: UserFilterInput) {
    users(filter: $filter) {
      items {
        _id
        email
        firstName
        lastName
        roles
        adminStatus
        isSmartCfoAdmin
        createdAt
        blockedFeatures
        modulePermissions {
          moduleId
          hasAccess
          excludedFeatures
        }
      }
      totalCount
      page
      pageSize
      totalPages
    }
  }
`

export const GET_USER = gql`
  query GetUser($id: String!) {
    user(id: $id) {
      _id
      emails {
        address
        verified
      }
      roles
      profile {
        firstName
        lastName
      }
      createdAt
      adminStatus
      isSmartCfoAdmin
      deactivatedAt
      deactivatedByEmail
      deactivationReason
      modulePermissions {
        moduleId
        hasAccess
        excludedFeatures
      }
      statusHistory {
        previousStatus
        newStatus
        changedAt
        changedByEmail
        comment
        commentAuthorId
        commentAuthorEmail
        commentedAt
      }
      roleHistory {
        previousRoles
        newRoles
        changedAt
        changedByEmail
        comment
        commentAuthorId
        commentAuthorEmail
        commentedAt
      }
      permissionHistory {
        changedAt
        changedByEmail
        modulesRestricted
        modulesAdded
        modulesRemoved
        changeDescription
        comment
        commentAuthorId
        commentAuthorEmail
        commentedAt
      }
      companyHistory {
        action
        companiesCount
        companyNames
        changedAt
        changedByEmail
        comment
        commentAuthorId
        commentAuthorEmail
        commentedAt
      }
      blockedFeatures
    }
  }
`

export const GET_USER_STATS = gql`
  query GetUserStats {
    userStats {
      totalUsers
      activeUsers
      deactivatedUsers
      adminUsers
      collaboratorUsers
      regularUsers
    }
  }
`

// === MUTATIONS ===

export const UPDATE_USER_STATUS = gql`
  mutation UpdateUserStatus($input: UpdateUserStatusInput!) {
    updateUserStatus(input: $input) {
      _id
      adminStatus
    }
  }
`

export const UPDATE_USER_ROLES = gql`
  mutation UpdateUserRoles($input: UpdateUserRolesInput!) {
    updateUserRoles(input: $input) {
      _id
      roles
    }
  }
`

export const TOGGLE_USER_ACTIVE = gql`
  mutation ToggleUserActive($input: ToggleUserActiveInput!) {
    toggleUserActive(input: $input) {
      _id
      adminStatus
      deactivatedAt
      deactivatedByEmail
      deactivationReason
    }
  }
`

// === PERMISOS GRANULARES ===

export const GET_AVAILABLE_MODULES = gql`
  query GetAvailableModules {
    availableModules {
      id
      name
      features
      subModules {
        id
        name
      }
    }
  }
`

export const GET_USER_WITH_PERMISSIONS = gql`
  query GetUserWithPermissions($id: String!) {
    user(id: $id) {
      _id
      emails {
        address
        verified
      }
      roles
      profile {
        firstName
        lastName
      }
      createdAt
      adminStatus
      isSmartCfoAdmin
      modulePermissions {
        moduleId
        hasAccess
        excludedFeatures
      }
    }
  }
`

export const UPDATE_USER_PERMISSIONS = gql`
  mutation UpdateUserPermissions($input: UpdateUserPermissionsInput!) {
    updateUserPermissions(input: $input) {
      _id
      modulePermissions {
        moduleId
        hasAccess
        excludedFeatures
      }
    }
  }
`

export const UPDATE_MODULE_PERMISSION = gql`
  mutation UpdateModulePermission($input: UpdateModulePermissionInput!) {
    updateModulePermission(input: $input) {
      _id
      modulePermissions {
        moduleId
        hasAccess
        excludedFeatures
      }
    }
  }
`

export const CHECK_MODULE_ACCESS = gql`
  query CheckModuleAccess($userId: String!, $moduleId: String!) {
    userHasModuleAccess(userId: $userId, moduleId: $moduleId)
  }
`

export const CHECK_FEATURE_ACCESS = gql`
  query CheckFeatureAccess($userId: String!, $moduleId: String!, $featureId: String!) {
    userHasFeatureAccess(userId: $userId, moduleId: $moduleId, featureId: $featureId)
  }
`

export const UPDATE_USER_HISTORY_COMMENT = gql`
  mutation UpdateUserHistoryComment($input: UpdateHistoryCommentInput!) {
    updateUserHistoryComment(input: $input) {
      _id
    }
  }
`

export const DELETE_USER = gql`
  mutation DeleteUser($input: DeleteUserInput!) {
    deleteUser(input: $input) {
      success
      message
      deletedUserId
    }
  }
`

export const GET_DELETED_USERS_HISTORY = gql`
  query GetDeletedUsersHistory($filter: DeletedUsersFilterInput) {
    deletedUsersHistory(filter: $filter) {
      items {
        _id
        action
        entityId
        entityType
        snapshot {
          email
          emails {
            address
            verified
          }
          firstName
          lastName
          roles
          adminStatus
          createdAt
          updatedAt
          isSmartCfoAdmin
          companies {
            companyId
            companyName
            companyRut
            role
          }
          companiesCount
        }
        performedByUserId
        performedByEmail
        reason
        performedAt
      }
      totalCount
      page
      pageSize
      totalPages
    }
  }
`

export const UPDATE_USER_BLOCKED_FEATURES = gql`
  mutation UpdateUserBlockedFeatures($input: UpdateUserBlockedFeaturesInput!) {
    updateUserBlockedFeatures(input: $input) {
      _id
      blockedFeatures
    }
  }
`

export const DELETE_USER_HISTORY_COMMENT = gql`
  mutation DeleteUserHistoryComment($input: DeleteHistoryCommentInput!) {
    deleteUserHistoryComment(input: $input) {
      _id
    }
  }
`

// === BULK OPERATIONS ===

export const BULK_UPDATE_USER_BLOCKED_FEATURES = gql`
  mutation BulkUpdateUserBlockedFeatures($input: BulkUpdateUserBlockedFeaturesInput!) {
    bulkUpdateUserBlockedFeatures(input: $input) {
      success
      failed
      message
    }
  }
`

export const BULK_UPDATE_USER_PERMISSIONS = gql`
  mutation BulkUpdateUserPermissions($input: BulkUpdateUserPermissionsInput!) {
    bulkUpdateUserPermissions(input: $input) {
      success
      failed
      message
    }
  }
`
